module.exports = __webpack_public_path__ + "img/admin_adv_09.76a097da.png";